var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrozenRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.034000000000001,
    cy: 84.454,
    r: 3.684,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.476 25.366 c -0.034 -0.513 -0.058 -1.029 -0.058 -1.55 c 0 -12.714 10.307 -23.021 23.021 -23.021 c 9.198 0 17.133 5.396 20.82 13.193 c 2.777 -1.972 6.162 -3.142 9.827 -3.142 c 8.48 0 15.49 6.212 16.778 14.329 C 85.703 26.772 90 32.101 90 38.447 c 0 7.607 -6.167 13.774 -13.774 13.774 H 13.774 C 6.167 52.221 0 46.054 0 38.447 C 0 32.342 3.976 27.173 9.476 25.366 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(67,144,179)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.105 76.565 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 4.919 -14.268 c 0.183 -0.533 0.763 -0.819 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -4.919 14.268 C 9.926 76.299 9.529 76.565 9.105 76.565 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.433 82.07 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.761 -0.82 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 L 18.4 81.381 C 18.254 81.804 17.858 82.07 17.433 82.07 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.559 76.565 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 4.919 -14.268 c 0.183 -0.533 0.763 -0.819 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -4.919 14.268 C 30.38 76.299 29.984 76.565 29.559 76.565 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.888 82.07 c -0.11 0 -0.223 -0.018 -0.334 -0.056 c -0.534 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.291 -9.546 c 0.183 -0.534 0.761 -0.82 1.3 -0.633 c 0.534 0.184 0.817 0.766 0.633 1.3 l -3.291 9.546 C 38.709 81.804 38.312 82.07 37.888 82.07 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.014 76.565 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 4.919 -14.268 c 0.184 -0.534 0.764 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -4.919 14.268 C 50.835 76.299 50.438 76.565 50.014 76.565 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.342 82.07 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 l 3.292 -9.546 c 0.184 -0.533 0.764 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -3.292 9.546 C 59.163 81.804 58.767 82.07 58.342 82.07 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.468 76.565 c -0.111 0 -0.223 -0.018 -0.334 -0.056 c -0.533 -0.184 -0.817 -0.766 -0.633 -1.3 L 74.42 60.94 c 0.184 -0.534 0.766 -0.816 1.3 -0.633 c 0.533 0.184 0.817 0.766 0.633 1.3 l -4.919 14.268 C 71.289 76.299 70.893 76.565 70.468 76.565 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.484,
    cy: 84.454,
    r: 3.684,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.943999999999996,
    cy: 84.454,
    r: 3.684,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.394,
    cy: 84.454,
    r: 3.684,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(123,216,247)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozenRain);
export default __webpack_public_path__ + "static/media/frozen-rain.909b10aa4adfd1cdcb8d747945f637dc.svg";
export { ForwardRef as ReactComponent };